import { UnwrapPromise } from "@prisma/client";
import { FiArrowRight } from "react-icons/fi";
import { LoaderFunction, useLoaderData } from "remix";
import { ButtonLink } from "~/components/Button";
import { ContentBlock } from "~/components/ContentBlock";
import { HeroTeaser } from "~/components/HeroTeaser";
import { Logo } from "~/components/Logo";
import { ContentBlockModel, getContentBlock } from "~/utils/contentBlocks";
import { getCurrentFestival } from "~/utils/festival.server";
import { useIsLoggedIn } from "~/utils/useIsLoggedIn";

export interface LoaderProps {
  teaserBlock: ContentBlockModel;
  currentFestival: UnwrapPromise<ReturnType<typeof getCurrentFestival>>;
}

export const handle = {
  hideBreadcrumbs: true,
};

export const loader: LoaderFunction = async ({ request }) => {
  const teaserBlock = await getContentBlock("/index/teaser");
  const currentFestival = await getCurrentFestival();

  return { teaserBlock, currentFestival };
};

export default function Index() {
  const { teaserBlock, currentFestival } = useLoaderData<LoaderProps>();
  const isLoggedIn = useIsLoggedIn();

  return (
    <>
      <HeroTeaser>
        <div className="flex flex-col items-center gap-10 mt-10">
          <div className="max-w-full w-[280px] md:w-[450px]">
            <Logo />
          </div>
          <div className="prose-headings:text-primary-600">
            <ContentBlock block={teaserBlock} editable={isLoggedIn} />
            {!!currentFestival && (
              <div className="my-6 flex flex-col md:flex-row gap-3">
                <ButtonLink to={`/${currentFestival.slug}/events`}>
                  Zu den Veranstaltungen <FiArrowRight className="ml-2" />
                </ButtonLink>
                <ButtonLink to={`/${currentFestival.slug}`} variant="ghost">
                  Mehr über das Festival <FiArrowRight className="ml-3" />
                </ButtonLink>
              </div>
            )}
          </div>
        </div>
      </HeroTeaser>
    </>
  );
}
